<template>
    <div class="protocol_search_item">
        <div class="top_info" v-for="({ material, equipment, measurement, analysis, protocolType } , idx ) in protocols">
            <div class="txt_cont">
                <div class="tit_label">
                    <span class="condition" :class="publicActive != 0 ? 'open' : null">{{publicActiveList[publicActive]}}</span>
                    <span v-if="uniqueNumber" class="label_color color_02">{{protocolType}}<em>|</em>{{uniqueNumber}}</span>
                    <span v-else class="label_color color_02">{{protocolType}}</span>
                    <span class="label_gray">{{`${fieldName.split(">").join(" / ")}`}}</span>
                </div>
                <a href="javascript:void(0);" @click="goToDetail(protocolId,'tree',1)" class="tit_link"
                   v-html="thisMyPage ? processName : name">
                </a>
                <!--                현재 관리되고 있지 않은 데이터의 경우 빈 화면으로 퍼블리싱 적용 진행.​ -->
                <!--                영문 한글명 토글 구현시 사용.-->
                <!--                <p class="txt_info" v-html="nameEng"></p>-->
                <ul class="protocol_label_list">
                    <li class="label_01 material"
                        v-for="name in  material ? material.split(';') : []"
                        v-if="name.trim() !== ''"
                    >
                        <span>{{ name }}</span>
                    </li>
                    <li class="label_02 measurement"
                        v-for="name in  measurement ? measurement.split(';') : []"
                        v-if="name.trim() !== ''"
                    >
                        <span>{{ name }}</span>
                    </li>
                    <li class="label_04 analysis"
                        v-for="name in  analysis ? analysis.split(';') : []"
                        v-if="name.trim() !== ''"
                    >
                        <span>{{ name }}</span>
                    </li>
                    <li class="label_03 equipment"
                        v-for="name in  equipment ? equipment.split(';') : []"
                        v-if="name.trim() !== ''"
                    >
                        <span>{{ name }}</span>
                    </li>
                </ul>
                <!--                현재 관리되고 있지 않은 데이터의 경우 빈 화면으로 퍼블리싱 적용 진행.​ -->
                <!--                <p class="txt_info"><span class="highlight">XPS</span> Skutterudite, CoSb3, 합성법, 열전소재, 에너지환경</p>-->
            </div>
        </div>
        <div class="bottom_info">
            <ul class="user_set">
                <li>{{lastEditDate}}</li>
                <li>책임작성자 : {{userName}}</li>
                <li v-if="collaborators.length">공동작성자 :
                    <span
                            v-for="(collaborator,collaboratorKey) in collaborators"
                            :key="collaboratorKey"
                    >{{`${collaboratorKey != 0 ? " ,"+(collaborator.userName??collaborator.name) : (collaborator.userName??collaborator.name)}`}}</span>
                </li>
            </ul>
            <ul class="btn_set">
                <li><a href="javascript:void(0);" class="tree_btn" @click="goToDetail(protocolId,'tree',1)">트리보기</a>
                </li>
                <li><a href="javascript:void(0);" class="wiki_btn" @click="goToDetail(protocolId,'wiki',1)">위키보기</a>
                </li>
                <li v-if="thisMyPage">
                    <a href="javascript:void(0);" 
                       v-if="thisMyPage" 
                       @click="$emit('goToProtocolEditor');" 
                       class="editor_move_btn">에디터로 이동
                    </a>
                </li>
                <li class="process" v-if="processType == 'NORMAL'"><a href="javascript:void(0);"
                                                                      class="process_chart_btn"
                                                                      @click="$emit('goToProcessDetail')">공정도 바로가기</a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>

    export default {
        props: {
            protocolData: {
                type: Object, default: {}
            },
            thisMyPage: {
                type: Boolean, default: false
            }
        },
        components: {},
        data() {
            return {
                inProcessId: '',
                processName: '',
                userName: '',
                fieldName: '',
                createdDate: '',
                thumbnail: '',
                editerMode: false,
                protocols: [],
                collaborators: [],
                accordionToggle: false,
                processType: "",

                lastEditDate: "",
                protocolId: null,
                uniqueNumber: null,
                publicActive: 0,

                publicActiveList: {
                    0: "비공개",
                    1: "일반회원 공개",
                    2: "위원,간사 공개",
                },
            }
        },
        computed: {},
        watch: {
            process(value) {
                this.init();
            }
        },
        mounted() {
            this.init();
            if(this.protocols?.length == 0){
                this.protocols.push(this.protocolData);
            }
            this.protocolId = this.protocols[0]["protocolId"];
            
            // 공개 데이터가 아님 (작성목록)
            if(this.thisMyPage) {
                // 최종 수정일 또는 생성일 화면에 보여줄 형식에 맞게 수정.
                if (!this.updatedDate) {
                    this.lastEditDate = this.createdDate.substring(0, 10).split('-').join('.');
                } else {
                    this.lastEditDate = this.updatedDate.substring(0, 10).split('-').join('.');
                }
            }else {
                if(this.revisionDate.length == 0){
                    this.lastEditDate = this.releaseDate.substring(0, 10).split('-').join('.');       
                }else{
                    this.lastEditDate = this.revisionDate.substring(0, 10).split('-').join('.');
                }
            }
        },
        methods: {
            init() {
                for (const item of Object.entries(this.protocolData)) {
                    if (item[0] === "processId")
                        this["inProcessId"] = item[1]
                    else
                        this[item[0]] = item[1]
                }
            },
            async moveToProcessPage() {
                const processId = this.inProcessId;

                let path = '/process/editor';
                if (this.editerMode === false) {
                    window.alert('해당 문서의 수정권한을 가지고 있지 않습니다.')
                    return;
                }
                const {href} = this.$router.resolve({
                    path,
                    query: {
                        processId,
                        editorType: 'process',
                        protocolId: null
                    }
                });
                window.open(href, '_blank');
            },
            goToDetail(protocolId, viewMode, tabIndex) {
                const beforeProcessId = null; 
                this.$emit("goToProtocolDetail", protocolId, viewMode, tabIndex, beforeProcessId);
            }
        }

    }
</script>